import qs from 'qs';

export const state = () => ({
	scroll_position: 0,
	filtered_jobs: null,
	expired_jobs: [],
	search: null,
	filters: null,
	industry_filters: [],
	cursor: null,
	show_job_filters: false,
});

export const mutations = {
	setScrollPosition(state: any, payload: any) {
		state.scroll_position = payload;
	},
	setFilteredJobs(state: any, payload: any) {
		state.filtered_jobs = payload;
	},
	setExpiredJobs(state: any, payload: any) {
		state.expired_jobs = payload;
	},
	setSearch(state: any, payload: any) {
		state.search = payload;
	},
	setFilters(state: any, payload: any) {
		state.filters = payload;
	},
	setIndustryFilters(state: any, payload: any) {
		state.industry_filters = payload;
	},
	setCursor(state: any, payload: any) {
		state.cursor = payload;
	},
	setShowJobFilters(state: any, payload: any) {
		state.show_job_filters = payload;
	},
};

export const getters = {
	getScrollPosition: (state: any) => state.scroll_position,
	getFilteredJobs: (state: any) => state.filtered_jobs,
	getExpiredJobs: (state: any) => state.expired_jobs,
	getSearch: (state: any) => state.search,
	getFilters: (state: any) => state.filters,
	getIndustryFilters: (state: any) => state.industry_filters,
	getCursor: (state: any) => state.cursor,
	getShowJobFilters: (state: any) => state.show_job_filters,
};

export const actions = {
	// This is a temp action added to allow for load testing - should be removed afterwards
	// along with the LoadTest vue component
	getJobsForLoadTesting(state: any){
		let url = '/api/temp-all-jobs';

		return new Promise((resolve, reject) => {
			this.$axios.get(url).then(res => {
				resolve(res.data)
			}).catch(err => {
				reject(err)
			})
		})
	},

	getFilteredJobs(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			if (
				this.$router.history.current.path ===
				this.localePath({ path: '/saved-jobs' })
			) {
				state
					.dispatch('getFavouriteJobs')
					.then((res) => {
						resolve(res);
					})
					.catch((err) => {
						reject(err);
					});
			} else {
				state
					.dispatch('getAllJobs')
					.then((res) => {
						resolve(res);
					})
					.catch((err) => {
						reject(err);
					});
			}
		});
	},

	getFavouriteJobs(state: any, payload: any) {
		let url = payload?.url || '/api/jobs/favourites';

		let params = {
			search: state.state.search,
			job_type: state.state.filters?.job_type?.value,
			location_type: state.state.filters?.location_type?.value,
			industries: state.state.filters?.industries,
			interests: state.state.filters?.interests,
			cursor: state.state.cursor,
		};

		Object.keys(params).forEach((key) => {
			if (params[key] === null || params[key] === '') delete params[key];
		});

		return new Promise((resolve, reject) => {
			this.$axios
				.get(url, {
					params,
					paramsSerializer: (params) => {
						return qs.stringify(params, { arrayFormat: 'indices' });
					},
				})
				.then((res) => {
					let jobs;

					if (state.state.filtered_jobs) {
						jobs = JSON.parse(
							JSON.stringify(state.state.filtered_jobs),
						);
					}

					if (params.cursor) {
						jobs.data.push(...res.data.data);
						jobs.links = res.data.links;
						jobs.meta = res.data.meta;
					} else {
						jobs = res.data;
					}

					state.commit('setFilteredJobs', jobs);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getAllJobs(state: any, payload: any) {
		let url = payload?.url || '/api/search-jobs';

		let params = {
			title: state.state.search,
			job_type: state.state.filters?.job_type?.value,
			location_type: state.state.filters?.location_type?.value,
			industries: state.state.filters?.industries,
			interests: state.state.filters?.interests,
			include_suggestions: state.state.filters?.include_suggestions,
			cursor: state.state.cursor,
			is_bursary: state.state.filters?.is_bursary ? '1' : '0',
		};

		Object.keys(params).forEach((key) => !params[key] && delete params[key]);

		return new Promise((resolve, reject) => {
			this.$axios
				.get(url, {
					params,
					paramsSerializer: (params) => {
						return qs.stringify(params, { arrayFormat: 'indices' });
					},
				})
				.then((res) => {
					let jobs;

					if (state.state.filtered_jobs) {
						jobs = JSON.parse(
							JSON.stringify(state.state.filtered_jobs),
						);
					}

					if (params.cursor) {
						jobs.data.push(...res.data.data);
						jobs.links = res.data.links;
						jobs.meta = res.data.meta;
					} else {
						jobs = res.data;
					}

					state.commit('setFilteredJobs', jobs);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getExpiredJobs(state: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/jobs/expired')
				.then((res) => {
					state.commit('setExpiredJobs', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setScrollPosition(state: any, payload: any) {
		state.commit('setScrollPosition', payload);
	},

	setFilteredJobs(state: any, payload: any) {
		state.commit('setFilteredJobs', payload);
	},

	setExpiredJobs(state: any, payload: any) {
		state.commit('setExpiredJobs', payload);
	},

	setFavouriteJobs(state: any, payload: any) {
		state.commit('setFavouriteJobs', payload);
	},

	setSearch(state: any, payload: any) {
		state.commit('setSearch', payload);
	},

	setFilters(state: any, payload: any) {
		state.commit('setFilters', payload);
	},

	setIndustryFilters(state: any, payload: any) {
		state.commit('setIndustryFilters', payload);
	},

	setCursor(state: any, payload: any) {
		state.commit('setCursor', payload);
	},

	setShowJobFilters(state: any, payload: any) {
		state.commit('setShowJobFilters', payload);
	},
};
